import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const uspsRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "USPS" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { UspsCallback } = await import("./callback");
          return { Component: UspsCallback };
        },
      },
    ],
  },
];
